import React from "react";
import "./privacyPolicy.css";

const PrivacyPolicy = () => {
	return (
		<div className="privacy-page">
			<div className="privacy-container">
				<header className="privacy-header">
					<h1>HIPAA-Compliant Privacy Policy</h1>
					<div className="privacy-meta">
						<span>
							<strong>Effective Date:</strong> January 1, 2026
						</span>
						<span>
							<strong>Last Updated:</strong> January 1, 2026
						</span>
					</div>
				</header>

				<p className="privacy-intro">
					This Privacy Policy describes how <strong>Nexcaliber</strong> collects, uses, discloses, and
					protects information through its insurance enrollment mobile application.
				</p>

				<p className="privacy-highlight">
					This application may process <strong>Protected Health Information (PHI)</strong> and complies with
					the Health Insurance Portability and Accountability Act (HIPAA), where applicable.
				</p>

				<section>
					<h2>1. Information We Collect</h2>
					<ul>
						<li>
							<strong>Personal Identifiers:</strong> Name, date of birth, contact details, member IDs
						</li>
						<li>
							<strong>Health & Insurance Data (PHI):</strong> Coverage details, enrollment data, claims,
							EOBs
						</li>
						<li>
							<strong>Documents:</strong> Digital ID cards, policy documents, claims files
						</li>
						<li>
							<strong>Technical Data:</strong> Device information, logs, crash reports
						</li>
					</ul>
				</section>

				<section>
					<h2>2. Use of Information</h2>
					<p>
						Information is used solely for insurance enrollment, benefits administration, claims tracking,
						notifications, customer support, and compliance with legal and regulatory obligations.
					</p>
				</section>

				<section>
					<h2>3. HIPAA Compliance</h2>
					<ul>
						<li>Nexcaliber acts as a Business Associate where applicable</li>
						<li>PHI is processed only for permitted purposes under applicable BAAs</li>
						<li>Administrative, technical, and physical safeguards are maintained</li>
					</ul>
				</section>

				<section>
					<h2>4. Sharing of Information</h2>
					<p>
						Information is shared only with insurers, third-party administrators, authorized service
						providers, employers (when applicable), and regulatory authorities.
					</p>
				</section>

				<section>
					<h2>5. Data Security</h2>
					<p>
						We use encryption, access controls, audit logging, monitoring, and industry best practices to
						protect confidentiality and integrity.
					</p>
				</section>

				<section>
					<h2>6. Data Retention</h2>
					<p>
						Information is retained only as long as necessary to satisfy insurance, legal, and regulatory
						requirements.
					</p>
				</section>

				<section>
					<h2>7. Individual Rights</h2>
					<p>
						Individuals may request access, correction, disclosure accounting, and communication preferences
						as permitted by law.
					</p>
				</section>

				<section>
					<h2>8. Children & Dependents</h2>
					<p>
						Dependent information is collected solely for coverage administration and related insurance
						purposes.
					</p>
				</section>

				<section>
					<h2>9. Policy Updates</h2>
					<p>
						This Privacy Policy may be updated periodically. Revisions will be posted with an updated
						effective date.
					</p>
				</section>

				<footer className="privacy-footer">
					<h2>10. Contact Information</h2>
					<p>
						<strong>Nexcaliber</strong>
						<br />
						Email:{" "}
						<a
							href="mailto:
info@nexcaliber.com"
						>
							info@nexcaliber.com
						</a>
					</p>
				</footer>
			</div>
		</div>
	);
};

export default PrivacyPolicy;
